import { isAlive } from "./";

function findMaxOf(array, getMax, defaultValue = undefined){
	let max = defaultValue;
	array.forEach(element => {
		const value = getMax(element);
		if(max === undefined || value > max){
			max = value;
		}
	});
	return max;
}

function concatUnique(sources, targets, 
	predicate = (sources,item)=>sources.indexOf(item) === -1
){
	for(let i=0;i<targets.length;i+=1){
		if(predicate(sources,targets[i])){
			sources.push(targets[i]);
		}
	}
}

/**
 * Check if the target array is alive
 * @param {array} target 
 * @param {bool} moreThanZero 
 */
function isAliveArray(target, moreThanZero = true){
	if(isAlive(target) && Array.isArray(target)){
		if(moreThanZero && target.length === 0)
			return false;
		return true;
	}
	return false;
}
/**
 * Create an array from length.
 * @param {number} size 
 * @param {function} maker 
 */
function createLength(length, maker){
	const array = [];
	for(let i=0;i<length;i+=1){
		array.push(maker(i));
	}
	return array;
}
export default { findMaxOf, isAliveArray, concatUnique, createLength };


// WEBPACK FOOTER //
// ./src/util/aArray.js